var _rect, _rect2, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDemoIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5238_73362",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 40,
    height: 40
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5238_73362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.458 50.1699C23.736 50.1699 23.118 49.9129 22.604 49.3989C22.09 48.8849 21.833 48.2669 21.833 47.5449V41.1699H23.917V47.5449C23.917 47.6836 23.9723 47.8086 24.083 47.9199C24.1943 48.0306 24.3193 48.0859 24.458 48.0859H30.833V50.1699H24.458ZM41.167 50.1699V48.0859H47.542C47.6807 48.0859 47.8057 48.0306 47.917 47.9199C48.0277 47.8086 48.083 47.6836 48.083 47.5449V41.1699H50.167V47.5449C50.167 48.2669 49.91 48.8849 49.396 49.3989C48.882 49.9129 48.264 50.1699 47.542 50.1699H41.167ZM21.833 30.8359V24.4609C21.833 23.7389 22.09 23.1209 22.604 22.6069C23.118 22.0929 23.736 21.8359 24.458 21.8359H30.833V23.9199H24.458C24.3193 23.9199 24.1943 23.9753 24.083 24.0859C23.9723 24.1973 23.917 24.3223 23.917 24.4609V30.8359H21.833ZM48.083 30.8359V24.4609C48.083 24.3223 48.0277 24.1973 47.917 24.0859C47.8057 23.9753 47.6807 23.9199 47.542 23.9199H41.167V21.8359H47.542C48.264 21.8359 48.882 22.0929 49.396 22.6069C49.91 23.1209 50.167 23.7389 50.167 24.4609V30.8359H48.083Z",
    fill: "#587E85"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 41.458C34 41.458 32.1943 40.9303 30.583 39.875C28.9723 38.819 27.778 37.444 27 35.75C27.778 34.0553 28.9653 32.6733 30.562 31.604C32.1593 30.5347 33.972 30 36 30C38 30 39.8057 30.5347 41.417 31.604C43.0277 32.6733 44.222 34.0553 45 35.75C44.222 37.444 43.0347 38.819 41.438 39.875C39.8407 40.9303 38.028 41.458 36 41.458ZM36 39.708C37.4447 39.708 38.785 39.3607 40.021 38.666C41.257 37.972 42.264 37 43.042 35.75C42.264 34.5 41.257 33.5277 40.021 32.833C38.785 32.1383 37.4447 31.791 36 31.791C34.5553 31.791 33.215 32.1383 31.979 32.833C30.743 33.5277 29.736 34.5 28.958 35.75C29.736 37 30.743 37.972 31.979 38.666C33.215 39.3607 34.5553 39.708 36 39.708ZM36 37.708C36.5553 37.708 37.0207 37.5137 37.396 37.125C37.7707 36.7357 37.958 36.2773 37.958 35.75C37.958 35.194 37.7637 34.7287 37.375 34.354C36.9863 33.9787 36.528 33.791 36 33.791C35.4447 33.791 34.9793 33.9857 34.604 34.375C34.2293 34.7637 34.042 35.222 34.042 35.75C34.042 36.3053 34.2363 36.7703 34.625 37.145C35.0137 37.5203 35.472 37.708 36 37.708Z",
    fill: "#A9CF3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemoIcon2);
export default __webpack_public_path__ + "static/media/demo-icon2.43443b4126371df56a40777d9264e902.svg";
export { ForwardRef as ReactComponent };